<template lang="pug">
.ladder-left-container
  .zeroBuy(v-if="zeroBuyCardShow")
    img(src="https://m.hellobike.com/resource/helloyun/22871/5Bg4SZgRZ1.png")
  .mouth-card-v2(v-if="!zeroBuyCardShow && !freeRightsVersion() ")
    .mouth-card-line-one
      div(style="display:flex")
        .top-icon 特权1
        div(style="margin-top:-0.02rem") {{ versionWord(version) }}
      .only-buy(v-if="showCard()" @click="goRide")
        div 仅购骑行卡
        img.go-card(src="https://m.hellobike.com/resource/helloyun/08345/v-LOjgfLVO.png?x-oss-process=image/quality,q_80")
    CardChooseList(v-if="!isNewType && aggCardList && aggCardList.length>0"
      :aggCardList="aggCardList"
      :anchoredVersion="anchoredVersion"
      @chooseCard="getChooseCard")
    RideMonthTemplate.ride-card(
      :type="cardType"
      :status="'receivable'"
      :cardInfo="cardInfo"
    )
  .coupon-card
    .coupon-card-line-one
      .left
        .top-icon(v-if="!freeRightsVersion()") {{zeroBuyCardShow?'特权1':'特权2'}}
        .free-title-text(v-if="freeRightsVersion()") 月月免费领
          span.free-brown-text 专属优惠券
        div(style="margin-top:-0.02rem" v-else) 专属权益月月享
      .tip(v-if="groupSubhead")
        img(src="https://m.hellobike.com/resource/gallery/43/7cIhET8h_17899291.png")
        .tip-text {{groupSubhead}}
    .coupon-card-list
      .list(:style="{ 'justify-content': couponsList.length < 4 ? 'center' : ''}")
        CouponOpenedLotteryNew.new-coupon-item(v-for="(item,index) in couponsList"
          :item="item"
          :vipOpen="false"
        )
      .list(
        v-if="couponsListBottom.length"
        :style="listBottomStyle"
      )
        CouponOpenedLotteryNew.new-coupon-item(v-for="(item,index) in couponsListBottom"
          :item="item"
          :vipOpen="false"
        )
    .bottom-word(v-if="showBottom")  限时升级权益仅首月生效，次月起恢复成原权益
</template>
<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { PropVersionMap } from '@/const/vip';
import CouponOpenedLotteryNew from './coupon-opened-lottery-new.vue';
import couponsItems from './coupons-Items.vue';
import couponsItemNew from './coupons-Items-new.vue';
import RideMonthTemplate from './ride-month-template.vue';
import { filterNoOpenData } from '../utils';
import CardChooseList from './card-choose-list';

export default {
  components: {
    couponsItemNew,
    couponsItems,
    RideMonthTemplate,
    CardChooseList,
    CouponOpenedLotteryNew,
  },
  props: {
    groupList: {
      type: Array,
      required: true,
    },
    rideCardInfo: {
      type: Object,
      required: true,
    },
    expandAllPropertyAB: {
      type: String,
      default: 'N',
    },
    // unOpenPageShowStyle: {
    //   type: String,
    //   default: '',
    // },
    zeroBuyCardShow: {
      type: Boolean,
      default: false,
    },
    version: {
      type: String,
      default: '',
    },
    bikeCardShowStyle: {
      type: String,
      default: '',
    },
    isNewType: {
      type: Boolean,
      default: false,
    },
    aggCardList: {
      type: Array,
      default: () => [],
    },
    anchoredVersion: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      couponList: [{}, {
        coupons: null,
      }],
      v2Bg: 'background:#2fa8fa',
      vBgEbike: 'background: linear-gradient(90deg, #25C0F5 0%, #00AFEA 100%);',
      chooseCardIndex: 0,
      cardInfo: {},
      // couponsList: [],
    };
  },
  inject: ['freeRightsVersion'], // 从父组件注入freeRightsVersion
  computed: {
    backgroundUrl() {
      return this.unOpenCouponGameAB()
        ? 'https://m.hellobike.com/resource/gallery/43/7OBbfjAXgN.png'
        : 'https://m.hellobike.com/resource/helloyun/08345/DEdG303wDg.png?x-oss-process=image/quality,q_80';
    },
    backgroundHeight() {
      return this.unOpenCouponGameAB() ? '0.91rem;' : '0.84rem;';
    },
    showBottom() {
      const tempList = this.couponList.filter((x) => x.vipExtendProperty);
      if (tempList.length > 0) {
        return true;
      } return false;
    },
    couponsList() {
      const filteredList = filterNoOpenData(this.groupList, this.version).splice(0, 4);
      return (filteredList[1].coupons).splice(0, 4);
    },
    couponsListBottom() {
      const filteredList = filterNoOpenData(this.groupList, this.version)[1].coupons.slice(4);
      if (filteredList && filteredList.length) {
        return filteredList;
      }
      return [];
    },
    groupSubhead() {
      return (this.groupList && this.groupList[1] && this.groupList[1].groupSubhead) || '';
    },
    listBottomStyle() {
      if (this.couponsListBottom && this.couponsListBottom.length > 4) {
        return {
          'justify-content': 'flex-start',
          'overflow-x': 'auto',
        };
      }
      return {
        'justify-content': this.couponsListBottom && this.couponsListBottom.length < 4 ? 'center' : '',
      };
    },
    cardType() {
      if (this.version === PropVersionMap.RIDE_ONE_CENT) {
        return 'oneCentRide';
      }
      return this.isEbike(this.version) ? 'ebike' : 'ride';
    },
  },
  watch: {
    aggCardList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.cardInfo = val[this.chooseCardIndex];
      },
    },
  },
  mounted() {
  },
  methods: {
    getChooseCard(val) {
      this.$emit('chooseCard', val);
      this.chooseCardIndex = val;
      this.cardInfo = val[this.chooseCardIndex];
    },
    isEbike(version) {
      return version.includes('ebike');
    },
    versionWord(val) {
      if (val.includes('ebike')) {
        return '助力车骑行卡';
      }
      return '单车卡';
    },
    getCardBg() {
      if (this.version.includes('ebike')) {
        return this.vBgEbike;
      }
      return this.v2Bg;
    },
    getCardColor(version) {
      if (version.includes('ebike')) {
        return 'card-ebike';
      }
      return 'card-v2';
    },
    goRide() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_bikeVIP_buycard',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (env.isEasyBikeApp) {
        window.location.href = this.rideCardInfo.appJumpUrl;
      }
      if (env.isAliMP || env.isAliMPMonitor || env.isAlipayBrowser) {
        window.location.href = this.rideCardInfo.aliJumpUrl;
      }
    },
    showCard() {
      if (this.rideCardInfo) {
        if (this.rideCardInfo.onlyBuyCardSwitch) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_bikeVIP_buycard',
            contentId: 'platform_bikeVIP_buycard',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        return this.rideCardInfo.onlyBuyCardSwitch;
      }
      return false;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../style.less';

.ladder-left-container {
  padding: 0.07rem 0.12rem 0.08rem 0.12rem;
  margin-top: 0.05rem;

  .zeroBuy {
    margin-top: 0.07rem;
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: center;

    img {
      width: 2.42rem;
      height: 0.22rem;
    }
  }

  .mouth-card-v2 {
    border-radius: 0.17rem;
    border: 0.005rem solid #ebeef0;
    background: #fff;
    width: 100%;
    flex-shrink: 0;
    padding: 0.12rem 0 0.135rem 0.15rem;

    .mouth-card-line-one {
      color: #242729;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.15rem;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
      line-height: 0.22rem;

      .title-icon {
        width: 0.4rem;
        height: 0.18rem;
        margin-right: 0.05rem;
      }

      .top-icon {
        background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
        height: 0.18rem;
        border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
        color: #fffae8;
        font-size: 0.12rem;
        text-align: center;
        line-height: 0.18rem;
        padding: 0 0.05rem;
        margin-right: 0.05rem;
      }
    }

    .ride-card {
      margin-right: 0.16rem;
    }

    .only-buy {
      display: flex;
      color: #879099;
      font-size: 0.14rem;

      img.go-card {
        width: 0.12rem;
        height: 0.12rem;
        margin-top: 0.05rem;
      }
    }

    .mouth-card-img {
      margin-top: 0.11rem;
      width: 100%;
      height: 0.72rem;
      overflow: hidden;
      border-radius: 0.1rem;
      background: #2fa8fa;
      position: relative;

      .card-info-line-one {
        color: #fff;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.16rem;
        font-weight: 500;
        line-height: 0.26rem;
        margin-top: 0.14rem;
        margin-left: 0.2rem;
      }

      .card-info-line-two {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #fff;
        margin-left: 0.2rem;
        margin-top: 0.02rem;
      }

      .card-v2 {
        background: #eaf6ff;
        border-radius: 0.15rem 0 0.1rem 0;
        width: 0.75rem;
        height: 0.24rem;
        position: absolute;
        bottom: 0;
        right: 0;
        color: #08f;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.14rem;
        font-weight: 500;
        text-align: center;
        line-height: 0.24rem;
      }

      .card-ebike {
        background: #e6f7fe;
        border-radius: 0.15rem 0 0.1rem 0;
        width: 0.75rem;
        height: 0.24rem;
        position: absolute;
        bottom: 0;
        right: 0;
        color: #00a2d9;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.14rem;
        font-weight: 500;
        text-align: center;
        line-height: 0.24rem;
      }
    }
  }

  .coupon-card {
    margin-top: 0.08rem;
    border-radius: 0.16rem;
    padding: 0.12rem 0 0.14rem 0.12rem;
    background: #fff;

    .coupon-card-list {
      margin-top: 0.1rem;
      width: 100%;
      height: auto;
      position: relative;
      overflow: hidden;

      .list {
        display: flex;
        overflow-x: hidden;
        justify-content: flex-start;

        .new-coupon-item {
          margin-right: 0.05rem;
        }

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }

        &:first-child {
          margin-bottom: 0.08rem;
        }

        &:last-child {
          padding-right: 0.06rem;
        }
      }
    }

    .coupon-card-line-one {
      display: flex;
      line-height: 0.22rem;
      color: #242729;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.15rem;
      font-weight: 500;
      align-items: center;
      justify-content: space-between;

      .tip {
        // align-self: center;
        display: flex;
        margin-right: 0.16rem;

        img {
          width: 0.28rem;
          height: 0.11rem;
          margin-right: 0.01rem;
        }

        .tip-text {
          line-height: 0.14rem;
          height: 0.14rem;
          color: #879099;
          font-family: "PingFang SC", sans-serif;
          font-size: 0.11rem;
        }
      }

      .left {
        display: flex;

        .top-icon {
          background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
          height: 0.18rem;
          border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
          color: #fffae8;
          font-size: 0.12rem;
          text-align: center;
          line-height: 0.18rem;
          padding: 0 0.05rem;
          margin-right: 0.05rem;
        }
      }
    }

    .bottom-word {
      margin-top: 0.08rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.16rem;
      color: #879099;
      padding: 0 0.1rem;
    }
  }
}

.free-rights-version {
  .ladder-left-container {
    padding: 0;
    margin: 0 0.08rem;

    .coupon-card {
      padding: 0.12rem 0 0.12rem 0.09rem;

      .coupon-card-line-one {
        padding: 0.02rem 0 0 0.05rem;
      }

      .coupon-card-list {
        .list {
          .new-coupon-item {
            margin-right: 0.05rem;
          }
        }
      }
    }
  }
}
</style>
